/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
export type Currency = ('AUD' | 'CAD' | 'EUR' | 'GBP' | 'NZD' | 'USD' | '%future added value');
import type { FragmentReference } from 'relay-runtime';
declare export opaque type trackSearchTaxonomies_viewer$ref: FragmentReference;
export type trackSearchTaxonomies_viewer = {|
  +selected_currency: ?Currency,
  +trackSearch: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
      |},
    |}>,
    +taxonomy_cardinalities: ?any,
    +term_cardinalities: ?any,
  |},
  +$refType: trackSearchTaxonomies_viewer$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "trackSearchTaxonomies_viewer",
  "type": "Viewer",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": null,
        "direction": "forward",
        "path": [
          "trackSearch"
        ]
      }
    ]
  },
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "count",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "offset",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "query",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "filters",
      "type": "TrackSearchFilters"
    },
    {
      "kind": "RootArgument",
      "name": "taxonomy_query",
      "type": "TaxonomyQuery"
    },
    {
      "kind": "RootArgument",
      "name": "license_params",
      "type": "[LicenseUsageParamsInput]"
    },
    {
      "kind": "RootArgument",
      "name": "sort",
      "type": "SearchSortOrder"
    },
    {
      "kind": "RootArgument",
      "name": "currency",
      "type": "Currency"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "selected_currency",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": "trackSearch",
      "name": "__trackSearch_trackSearch_connection",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "currency",
          "variableName": "currency",
          "type": "Currency"
        },
        {
          "kind": "Variable",
          "name": "filters",
          "variableName": "filters",
          "type": "TrackSearchFilters"
        },
        {
          "kind": "Variable",
          "name": "license_params",
          "variableName": "license_params",
          "type": "[LicenseUsageParamsInput]"
        },
        {
          "kind": "Variable",
          "name": "offset",
          "variableName": "offset",
          "type": "Int"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query",
          "type": "String"
        },
        {
          "kind": "Variable",
          "name": "sort",
          "variableName": "sort",
          "type": "SearchSortOrder"
        },
        {
          "kind": "Variable",
          "name": "taxonomy_query",
          "variableName": "taxonomy_query",
          "type": "TaxonomyQuery"
        }
      ],
      "concreteType": "TrackSearchResultConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackSearchResultEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "TrackSearchResult",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "__typename",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "cursor",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "taxonomy_cardinalities",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "term_cardinalities",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pageInfo",
          "storageKey": null,
          "args": null,
          "concreteType": "PageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "endCursor",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "hasNextPage",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node/*: any*/).hash = 'bb7a6320cd8dc10c379722c4037206a5';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/trackSearchTaxonomies_viewer.graphql.js